import React from "react";

const WhatsAppButton = () => {
  const phoneNumber = ""; // Add your WhatsApp number here (with country code, no + or spaces)
  const message = "Hello! I'd like to know more about BSides.";
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      style={{
        position: "fixed",
        bottom: "24px",
        right: "24px",
        zIndex: 9999,
        width: "56px",
        height: "56px",
        borderRadius: "50%",
        backgroundColor: "#25D366",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.25)",
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
        cursor: "pointer",
        textDecoration: "none",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.1)";
        e.currentTarget.style.boxShadow = "0 6px 16px rgba(0, 0, 0, 0.3)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.25)";
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        width="32"
        height="32"
        fill="#fff"
      >
        <path d="M16.004 0C7.165 0 .002 7.163.002 16c0 2.825.737 5.58 2.137 8.012L.014 32l8.204-2.094A15.94 15.94 0 0 0 16.004 32C24.837 32 32 24.837 32 16S24.837 0 16.004 0zm0 29.116a13.07 13.07 0 0 1-6.662-1.822l-.478-.284-4.86 1.242 1.3-4.735-.312-.496A13.05 13.05 0 0 1 2.89 16c0-7.23 5.884-13.116 13.114-13.116 7.23 0 13.112 5.886 13.112 13.116 0 7.228-5.882 13.116-13.112 13.116zm7.19-9.82c-.394-.197-2.332-1.15-2.694-1.282-.362-.131-.625-.197-.889.197-.263.394-1.02 1.282-1.25 1.545-.23.263-.46.296-.855.099-.394-.197-1.664-.613-3.17-1.956-1.172-1.044-1.963-2.334-2.193-2.728-.23-.394-.025-.607.173-.803.177-.177.394-.46.591-.69.197-.23.263-.394.394-.657.131-.263.066-.493-.033-.69-.099-.197-.889-2.14-1.218-2.93-.32-.77-.646-.665-.889-.678l-.757-.013c-.263 0-.69.099-1.051.493-.362.394-1.381 1.35-1.381 3.29 0 1.94 1.414 3.815 1.611 4.078.197.263 2.782 4.248 6.74 5.956.942.407 1.677.65 2.25.832.946.3 1.806.258 2.487.157.759-.113 2.332-.953 2.662-1.874.33-.92.33-1.71.23-1.874-.098-.164-.361-.263-.756-.46z" />
      </svg>
    </a>
  );
};

export default WhatsAppButton;
